

// import React, { useEffect, useState } from 'react';
// import {
//   TextField,
//   Button,
//   Grid,
//   Paper,
//   Typography,
//   Switch,
//   FormControlLabel,
//   MenuItem,
// } from '@mui/material';
// import { addReporter } from '../../../services/adminService';
// import { getCountries, getStatesByCountry, getCitiesByState } from '../../../services/apiService';

// const AddReporter = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     password: '',
//     profileImage: null,
//     country: '',
//     state: '',
//     city: '',
//     address: '',
//     dateOfBirth: '',
//     canDirectPost: false,
//     canDirectGoLive: false,
//     role: 'reporter',
//   });

//   const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);

//   useEffect(() => {
//     const loadCountries = async () => {
//       try {
//         const data = await getCountries();
//        setCountries(data.data)
//       } catch (err) {
//         console.error('Error loading countries:', err);
//       }
//     };
//     loadCountries();
//   }, []);

//   useEffect(() => {
//     if (formData.country) {
//       const fetchStates = async () => {
//         try {
//           const data = await getStatesByCountry(formData.country);
//           setStates(data.data);
//           setFormData((prev) => ({ ...prev, state: '', city: '' }));
//           setCities([]);
//         } catch (err) {
//           console.error('Error loading states:', err);
//         }
//       };
//       fetchStates();
//     }
//   }, [formData.country]);

//   useEffect(() => {
//     if (formData.state) {
//       const fetchCities = async () => {
//         try {
//           const data = await getCitiesByState(formData.state);
//           setCities(data.data);
//           setFormData((prev) => ({ ...prev, city: '' }));
//         } catch (err) {
//           console.error('Error loading cities:', err);
//         }
//       };
//       fetchCities();
//     }
//   }, [formData.state]);

//   const handleChange = (e) => {
//     const { name, value, type, checked, files } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const dataToSubmit = new FormData();
//     Object.keys(formData).forEach((key) => {
//       if (key === 'profileImage' && formData.profileImage) {
//         dataToSubmit.append('profileImage', formData.profileImage);
//       } else {
//         dataToSubmit.append(key, formData[key]);
//       }
//     });

//     try {
//       const response = await addReporter(dataToSubmit);
//       alert('Reporter created successfully!');
//       console.log(response);
//     } catch (error) {
//       alert('Error creating reporter!');
//       console.error(error);
//     }
//   };

//   return (
//     <Paper elevation={4} sx={{ p: 4, maxWidth: 900, margin: 'auto', mt: 4 }}>
//       <Typography variant="h5" gutterBottom>
//         Add Reporter
//       </Typography>
//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={2}>
//           {[
//             { label: 'Full Name', name: 'name' },
//             { label: 'Email', name: 'email', type: 'email' },
//             { label: 'Password', name: 'password', type: 'password' },
//             { label: 'Address', name: 'address' },
//             { label: 'Date of Birth', name: 'dateOfBirth', type: 'date' },
//           ].map((field, idx) => (
//             <Grid item xs={12} sm={6} key={idx}>
//               <TextField
//                 label={field.label}
//                 name={field.name}
//                 type={field.type || 'text'}
//                 fullWidth
//                 required
//                 InputLabelProps={field.type === 'date' ? { shrink: true } : {}}
//                 value={formData[field.name]}
//                 onChange={handleChange}
//               />
//             </Grid>
//           ))}

//           <Grid item xs={12} sm={6}>
//             <TextField
//               select
//               label="Country"
//               name="country"
//               value={formData.country}
//               onChange={handleChange}
//               fullWidth
//               required
//             >
//               {countries.map((country) => (
//                 <MenuItem key={country._id} value={country._id}>
//                   {country.name}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <TextField
//               select
//               label="State"
//               name="state"
//               value={formData.state}
//               onChange={handleChange}
//               fullWidth
//               required
//               disabled={!formData.country}
//             >
//               {states.map((state) => (
//                 <MenuItem key={state._id} value={state._id}>
//                   {state.name}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <TextField
//               select
//               label="City"
//               name="city"
//               value={formData.city}
//               onChange={handleChange}
//               fullWidth
//               required
//               disabled={!formData.state}
//             >
//               {cities.map((city) => (
//                 <MenuItem key={city._id} value={city._id}>
//                   {city.name}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   name="canDirectPost"
//                   checked={formData.canDirectPost}
//                   onChange={handleChange}
//                 />
//               }
//               label="Can Direct Post"
//             />
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   name="canDirectGoLive"
//                   checked={formData.canDirectGoLive}
//                   onChange={handleChange}
//                 />
//               }
//               label="Can Direct Go Live"
//             />
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <Button variant="outlined" component="label" fullWidth>
//               Upload Profile Image
//               <input
//                 hidden
//                 type="file"
//                 name="profileImage"
//                 accept="image/*"
//                 onChange={handleChange}
//               />
//             </Button>
//             {formData.profileImage && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Selected: {formData.profileImage.name}
//               </Typography>
//             )}
//           </Grid>

//           <Grid item xs={12}>
//             <Button type="submit" variant="contained" color="primary" fullWidth>
//               Create Reporter
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Paper>
//   );
// };

// export default AddReporter;


// src/components/pages/admin/AddReporterForm.jsx


import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  Switch,
  FormControlLabel,
  MenuItem,
} from '@mui/material';
import { addReporter } from '../../../services/adminService';
import {
  getCountries,
  getStatesByCountry,
  getCitiesByState,
} from '../../../services/apiService';

const AddReporterForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    address: '',
    dateOfBirth: '',
    country: '',
    state: '',
    city: '',
    role: 'reporter',
    profileImageFile: null,
    canDirectPost: false,
    canDirectGoLive: false,
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await getCountries();
        setCountries(res.data);
      } catch (err) {
        console.error('Error fetching countries:', err);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (formData.country) {
      getStatesByCountry(formData.country)
        .then((res) => setStates(res.data))
        .catch((err) => console.error('Error fetching states:', err));
    } else {
      setStates([]);
    }
  }, [formData.country]);

  useEffect(() => {
    if (formData.state) {
      getCitiesByState(formData.state)
        .then((res) => setCities(res.data))
        .catch((err) => console.error('Error fetching cities:', err));
    } else {
      setCities([]);
    }
  }, [formData.state]);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked });
    } else if (type === 'file') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSubmit = new FormData();
      Object.keys(formData).forEach((key) => {
        dataToSubmit.append(key, formData[key]);
      });

      const res = await addReporter(dataToSubmit);
      alert('Reporter added successfully!');
      setFormData({
        name: '', email: '', password: '', address: '',
        dateOfBirth: '', country: '', state: '', city: '',
        profileImageFile: null, canDirectPost: false, canDirectGoLive: false
      });
    } catch (err) {
      console.error('Error adding reporter:', err);
      alert('Failed to add reporter.');
    }
  };

  return (
    <Paper sx={{ padding: 3, maxWidth: 800, margin: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Add Reporter
      </Typography>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="name" label="Name"
              value={formData.name} onChange={handleChange} required
            />
          </Grid>
           <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="role" label="role"
              value={formData.role} onChange={handleChange} required disabled
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="email" label="Email"
              value={formData.email} onChange={handleChange} required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth type="password" name="password" label="Password"
              value={formData.password} onChange={handleChange} required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth name="address" label="Address"
              value={formData.address} onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth type="date" name="dateOfBirth"
              label="Date of Birth" InputLabelProps={{ shrink: true }}
              value={formData.dateOfBirth} onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="Country" name="country"
              value={formData.country} onChange={handleChange} required
            >
              {countries.map((c) => (
                <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="State" name="state"
              value={formData.state} onChange={handleChange} required
              disabled={!formData.country}
            >
              {states.map((s) => (
                <MenuItem key={s._id} value={s._id}>{s.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth select label="City" name="city"
              value={formData.city} onChange={handleChange} required
              disabled={!formData.state}
            >
              {cities.map((c) => (
                <MenuItem key={c._id} value={c._id}>{c.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth type="file" name="profileImageFile"
              onChange={handleChange} inputProps={{ accept: 'image/*' }}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={<Switch checked={formData.canDirectPost} onChange={handleChange} name="canDirectPost" />}
              label="Can Direct Post"
            />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={<Switch checked={formData.canDirectGoLive} onChange={handleChange} name="canDirectGoLive" />}
              label="Can Direct Go Live"
            />
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" type="submit">
              Add Reporter
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default AddReporterForm;





/////////////////////////////////////deziine







